"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _DescriptionSkeleton = require("./DescriptionSkeleton");
Object.keys(_DescriptionSkeleton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _DescriptionSkeleton[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _DescriptionSkeleton[key];
        }
    });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _constants[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _constants[key];
        }
    });
});
